/** Fade-out duration of the setup block. Shared by the styled transition and the hook timer that drops the steps. */
export const SETUP_EXIT_MS = 260;
